module.exports = __webpack_public_path__ + "media/components/journeys/route-icons/Off-Road-8851a478de80d7bde6aaa3edd21782ed.png";